import { Alert, Skeleton, Tabs } from "antd"
import { useRainforestMerchantStatusQuery, useRainforestReportingSessionQuery } from "../../../domain/invoicing/rainforestQueries"
import PaymentReport from "../../Rainforest/PaymentReport"
import DepositReport from "../../Rainforest/DepositReport"
import ChargebackReport from "../../Rainforest/ChargebackReport"
import SandboxActions from "./SandboxActions"

const getDefaultTab = () => {
  const hash = window.location.hash
  if (hash.includes('/payments/chargebacks')) return 'chargebacks'
  if (hash.includes('/payments/deposits')) return 'deposits'
  return 'payments'
}

const PaymentsReports = () => {
  const defaultTab = getDefaultTab()
  const reportingSessionQuery = useRainforestReportingSessionQuery()
  const merchantStatusQuery = useRainforestMerchantStatusQuery()

  if (reportingSessionQuery.isLoading || merchantStatusQuery.isLoading) {
    return <Skeleton />
  }

  if (merchantStatusQuery.data?.merchantStatus !== 'ACTIVE') {
    return <Alert message="Payments are not available until your SynkedUP Payments application is approved." type="info" />
  }

  if (merchantStatusQuery.isError || reportingSessionQuery.isError || !reportingSessionQuery.data?.sessionKey) {
    return <Alert message="There was a problem accessing payments. Please try again later." type="error" />
  }

  return <Tabs
    defaultActiveKey={defaultTab}
    items={[
      {
        key: 'payments',
        label: 'Payments',
        children: <PaymentReport rainforestSession={reportingSessionQuery.data} />
      },
      {
        key: 'chargebacks',
        label: 'Chargebacks',
        children: <ChargebackReport rainforestSession={reportingSessionQuery.data} />
      },
      {
        key: 'deposits',
        label: 'Deposits',
        children: <DepositReport rainforestSession={reportingSessionQuery.data} />
      }
    ]}
    destroyOnHidden={true}
    tabBarExtraContent={<SandboxActions merchantStatusData={merchantStatusQuery.data} />}
  />
}

export default PaymentsReports